import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AccountFacade } from '@mode/accounts/contract';
import { DataImportTilesComponent } from '@mode/reports/feature-data-import';
import { Observable } from 'rxjs';
import { EmptyReportHeaderComponent } from '../../empty-report-header/empty-report-header.component';

@Component({
  standalone: true,
  imports: [CommonModule, EmptyReportHeaderComponent, DataImportTilesComponent],
  selector: 'mode-empty-report-container',
  templateUrl: './empty-report-container.component.html',
  styleUrls: ['./empty-report-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmptyReportContainerComponent {
  org$ = this.accountFacade.currentOrg$;
  useDataImportTilesComponent$!: Observable<boolean>;

  constructor(private accountFacade: AccountFacade) {}
}
